//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText

export const TitleDescription = BaseUI.TitleDescription

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  right: 64px;
  width: 600px;
  z-index: 4;
`

export const Foreground = styled.div`
  position: absolute;
  top: 0px;
  left: -130px;
  height: 778px;
  width: 2324px;
  z-index: 2;
`

export const Midground = styled.div`
  position: absolute;
  bottom: 290px;
  left: -200px;
  height: 389px;
  width: 2421px;
  z-index: 1;
`

export const Background = styled.div`
  position: absolute;
  top: -100px;
  left: -227px;
  height: 498px;
  width: 2180px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Sweep/UI.js